import { useLocation } from "react-router-dom";

export function useIsWework() {
  const location = useLocation();

  return location.pathname.includes("wework");
}
